document.addEventListener('click', function (e) {
    const btnAbrir = e.target.closest('#formProduccionSoplado #btnModalAgregarLoteMateriaPrimaSoplado');
    if (!btnAbrir) return;

    const modalPadre = document.querySelector('#modalProduccionSoplado');
    const modalHijo  = document.querySelector('#modalAgregarLoteMateriaPrimaSoplado');

    if (!modalPadre || !modalHijo) {
        console.error("No se encontraron los modales.");
        alert("Error al abrir el modal. Por favor, intenta de nuevo.");
        window.location.reload();
        return;
    }

    const idEncabezado = modalPadre.querySelector('#idReporteSoplado').value;
    const idPreforma   = modalPadre.querySelector('#idMateriaPrima1Soplado').value;
    const txtPreforma  = modalPadre.querySelector('#descripcionMtPrima1Soplado').textContent;

    if (!idEncabezado || !idPreforma) {
        alert("Error al abrir el modal. Por favor, intenta de nuevo.");
        window.location.reload();
        return;
    }

    const inputIdEncabezado = modalHijo.querySelector('#idEncabezadoReporteSoplado');
    const inputIdPreforma   = modalHijo.querySelector('#idPreforma');
    const inputMaterial     = modalHijo.querySelector('#material');

    if (!inputIdEncabezado || !inputIdPreforma) {
        alert("Error al abrir el modal. Por favor, intenta de nuevo.");
        window.location.reload();
        return;
    }

    inputIdEncabezado.value = idEncabezado;
    inputIdPreforma.value   = idPreforma;
    if (inputMaterial) inputMaterial.value = txtPreforma || '';
});

document.addEventListener('submit', async function (e) {
    if (e.target.id !== 'formAgregarLoteMateriaPrimaSoplado') return;

    e.preventDefault();

    const formulario = e.target;
    const modalPadre = formulario.closest('.modal');
    const btnSubmit  = formulario.querySelector('#btnAgregarLoteMateriaPrimaSoplado');
    const spinner    = formulario.querySelector('#spinner');

    if (!formulario.checkValidity()) {
        formulario.reportValidity();
        return;
    }

    if (btnSubmit) btnSubmit.disabled = true;
    if (spinner) spinner.style.display = 'inline-block';

    formulario.querySelectorAll('.inputRojo').forEach(el => el.classList.remove('inputRojo'));

    try {
        const formData = new FormData(formulario);

        const respuesta = await fetch('/api/soplado/agregar-lote-materia-prima', {
            method: 'POST',
            body: formData,
            credentials: 'include'
        });

        let json;
        try {
            json = await respuesta.json();
        } catch {
            throw new Error('La respuesta del servidor no es JSON válido.');
        }

        if (!respuesta.ok) {
            console.error('Error HTTP:', respuesta.status, json);
            lanzarAlerta('Error al procesar la solicitud.', 'alerta-roja');
            return;
        }

        if (!json.result) {
            console.error('Respuesta inesperada:', json);
            lanzarAlerta('Respuesta inesperada del servidor.', 'alerta-roja');
            return;
        }

        const resultado = json.result;

        if (resultado.hayErrores) {
            resultado.errores.forEach(function (error) {
                lanzarAlerta(error.mensaje || 'Error de validación.', error.clase || 'alerta-roja');
                if (error.campo) {
                    const campo = formulario.querySelector('[name="' + error.campo + '"]');
                    if (campo) campo.classList.add('inputRojo');
                }
            });
            return;
        }

        const idReporte = formulario.querySelector('#idEncabezadoReporteSoplado').value || '';
        const params    = new URLSearchParams(window.location.search);
        const mes       = params.get('mes');
        const anio      = params.get('año');

        formulario.reset();
        if (modalPadre) modalPadre.classList.remove('modal--show');

        if (window.location.pathname === '/soplado/periodo') {
            window.actualizarModalReporteSoplado(idReporte);
            window.actualizarTableroSopladoPeriodo(mes, anio);
            window.actualizarTablaSopladoPeriodo(mes, anio);
        }

        if (window.location.pathname === '/zona-trabajo') {
            if (window.location.pathname === "/zona-trabajo") window.actualizarZonaTrabajo();
            window.actualizarModalReporteSoplado(idReporte);
        }

        lanzarAlerta(resultado.mensaje || 'Lote guardado con éxito.', 'alerta-verde');

    } catch (error) {
        console.error('Error:', error);
        lanzarAlerta('Error crítico al procesar la solicitud.', 'alerta-roja');
    } finally {
        if (btnSubmit) btnSubmit.disabled = false;
        if (spinner) spinner.style.display = 'none';
    }
});
